import parsePhoneNumberFromString from 'libphonenumber-js';

export const isMobileNumberValid = (value: string) => {
  const number = parsePhoneNumberFromString(value, 'SE');

  if (!number) {
    return false;
  }

  return number.isValid();
};
